import gql from 'graphql-tag';
import { minimalPostFragment } from '../fragments/minimal-post.fragment';

export const TimelineSubscriptionQl = gql`
  subscription timeLineChanges($tknStr: String!) {
    timeline(tknStr: $tknStr) {
      changeType
      post {
        ...minimalPostFragment
      }
    }
  }
  ${minimalPostFragment}
`;
